import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndoorAmateurBootstrapComponent } from './indoor-amateur-bootstrap/indoor-amateur-bootstrap.component';

const routes: Routes = [
  { path: '', component: IndoorAmateurBootstrapComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndoorWorldSeriesAmateurRankingRoutingModule {}
